import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BaseModule } from '@sb/library/base';
import { ButtonModule } from '@sb/library/button';
import { DesignBlocksModule } from '@sb/library/design-blocks';
import { FormFieldModule } from '@sb/library/form-field';
import { IconModule } from '@sb/library/icon';
import { IframeModule } from '@sb/library/iframe';
import { UtilityModule } from '@sb/library/utility';
import { CloneBlockDialogComponent } from './page/clone-block-dialog/clone-block-dialog.component';
import { WebsiteBlockComponent } from './block/website-block.component';
import { WebsiteNavigationSidebarComponent } from './navigation-sidebar/website-navigation-sidebar.component';
import { WebsitePageComponent } from './page/website-page.component';
import { WebsiteSvgsComponent } from './svgs/website-svgs.component';
import { ManagersModule } from '@sb/library/managers';

@NgModule({
    declarations: [
        WebsitePageComponent,
        WebsiteBlockComponent,
        WebsiteNavigationSidebarComponent,
        WebsiteSvgsComponent
    ],
    imports: [
        BaseModule,
        CommonModule,
        DesignBlocksModule,
        IconModule,
        DragDropModule,
        ScrollingModule,
        UtilityModule,
        IframeModule,
        MatSidenavModule,
        MatListModule,
        DesignBlocksModule,
        ButtonModule,
        FormFieldModule,
        CloneBlockDialogComponent,
        ManagersModule
    ],
    exports:[
        WebsitePageComponent,
        WebsiteBlockComponent,
        WebsiteNavigationSidebarComponent
    ]
})
export class WebsiteLibraryModule { }
